/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-labels */
import _ from 'lodash';
import random from 'random';
import {
  COMMON_PIPELINE_STAGES,
  COMMON_SYNC_DIRECTION,
  CONFIG_STATUS_LEVEL,
  CONFIG_TYPES,
  CRITERIA,
  CRM_ACTIVITY_TYPE_TEMPLATE,
  CRM_DEFAULT_OBJ_BASED_ON_ENTITY,
  CRM_VENDOR_NAMES,
  ENTITY_HEADER_MAP,
  ENTITY_LEVEL,
  FIELD_MAPPING_OUT_DESCRIPTION,
  FIELD_MAPPING_OUT_DESCRIPTION_CONTACT,
  NOTE_HEADER_MAP,
  PROPERTY_TYPE,
  RESERVED_ACTIVITY_TYPES_LOOKUP,
  SIDE_NAV_BAR_OPTIONS,
  STEP_BUILDER_MAP,
  SYNC_DIRECTION,
} from '../../constants/integrationConstants/crmConstants';
import { capitalizeFirstLetter, isIntersects } from '../commonUtil';
import { isFieldExist } from './crmDeletedPropertyUtils';
import {
  INTEGRATION_CRITERIA_TYPE,
  INTEGRATION_SYNC_TYPE,
  NA,
} from '../../constants/IntegrationConstants';

export const getEntityHeaderKeys = () => {
  return Object.keys(ENTITY_HEADER_MAP);
};

export const getNoteHeaderKeys = () => {
  return Object.keys(NOTE_HEADER_MAP);
};
export const findSideNavBarScreenType = (type) => {
  if (Object.values(CRITERIA).includes(type)) {
    return 'criteria';
  }
  return SIDE_NAV_BAR_OPTIONS.DEDUPLICATION;
};

export const isCriteriaType = (type) =>
  findSideNavBarScreenType(type) === 'criteria';

export const generatePipelineMap = (pipelines) => {
  const pipelineMap = {};
  const pipelineList = [];
  pipelines?.forEach((pipeline) => {
    const { id, label } = pipeline;
    pipelineMap[id] = pipeline;
    pipelineList.push({ id, label });
  });
  return { pipelineMap, pipelineList };
};

export const generateFieldId = () => {
  return random.int(1, 1000);
};

export const getCurrentConfig = (sideNavBarTab, stepBuilderTab) => {
  if (sideNavBarTab === CONFIG_TYPES.DEDUPLICATION) {
    return CONFIG_TYPES.DEDUPLICATION;
  }
  if (sideNavBarTab === CONFIG_TYPES.PARENT_LINK) {
    return CONFIG_TYPES.PARENT_LINK;
  }
  return STEP_BUILDER_MAP[stepBuilderTab];
};

export const findCondtionStatus = (conditionMap) => {
  let status = CONFIG_STATUS_LEVEL.COMPLETED;
  const conditions = Object.values(conditionMap);
  pipelineLoop: for (
    let conditionId = 0;
    conditionId < conditions.length;
    // eslint-disable-next-line no-plusplus
    conditionId++
  ) {
    const { pipeline, stageFrom, stageTo, properties } =
      conditions[conditionId];
    const pipelineCondtionStatus =
      pipeline && stageFrom.length > 0 && stageTo.length > 0;
    if (!pipelineCondtionStatus) {
      return CONFIG_STATUS_LEVEL.IN_PROGRESS;
    }

    const propertyArray = Object.values(properties);
    for (
      let propertyIndex = 0;
      propertyIndex < propertyArray.length;
      // eslint-disable-next-line no-plusplus
      propertyIndex++
    ) {
      const { propertyId, propertyValue } = propertyArray[propertyIndex];
      if (!(propertyId && propertyValue)) {
        status = CONFIG_STATUS_LEVEL.IN_PROGRESS;
        // eslint-disable-next-line no-labels
        break pipelineLoop;
      }
    }
  }

  return status;
};

export const findDataMappingStatus = (dataMappingMap) => {
  const dataMappings = Object.values(dataMappingMap);
  if (dataMappings.length === 0) return CONFIG_STATUS_LEVEL.IN_PROGRESS;
  for (const dataMapping of dataMappings) {
    const { velaris, crm } = dataMapping;
    if (!(velaris.fieldId && crm.fieldId)) {
      return CONFIG_STATUS_LEVEL.IN_PROGRESS;
    }
  }
  return CONFIG_STATUS_LEVEL.COMPLETED;
};

export const findInSyncFilterStatus = (filterMap) => {
  const filters = Object.values(filterMap);
  for (const filter of filters) {
    const { property, condition, value } = filter;
    if (!(property && condition && value))
      return CONFIG_STATUS_LEVEL.IN_PROGRESS;
  }
  return CONFIG_STATUS_LEVEL.COMPLETED;
};

export const enrichProperty = (property, propertyOptions) => {
  const propertyData = propertyOptions.find(
    (propertyOption) => property.propertyId === propertyOption.id
  );
  return {
    ...property,
    propertyLabel: propertyData.label,
    options: propertyData.options,
  };
};

export const checkConditionUniquenes = (
  currentCondtion,
  currentEntity,
  currentCriteria,
  otherConditions
) => {
  const { account, organization } = otherConditions;

  const orgConditionValidateResults = validateCondition(
    organization,
    ENTITY_LEVEL.ORGANIZATION,
    currentCondtion,
    currentEntity,
    currentCriteria
  );
  if (orgConditionValidateResults.isIdenticalCondtions) {
    return {
      isIdenticalCondtions: orgConditionValidateResults.isIdenticalCondtions,
      entity: orgConditionValidateResults.entity,
      criteria: orgConditionValidateResults.criteria,
      conditionName: orgConditionValidateResults.conditionName,
    };
  }
  const accountConditionValidateResults = validateCondition(
    account,
    ENTITY_LEVEL.ACCOUNT,
    currentCondtion,
    currentEntity,
    currentCriteria
  );
  return {
    isIdenticalCondtions: accountConditionValidateResults.isIdenticalCondtions,
    entity: accountConditionValidateResults.entity,
    criteria: accountConditionValidateResults.criteria,
    conditionName: accountConditionValidateResults.conditionName,
  };
};

const validateCondition = (
  conditionMap,
  entityLevel,
  currentCondtion,
  currentEntity,
  currentCriteria
) => {
  const criterias = Object.keys(conditionMap);
  let isIdenticalCondtions = false;
  let entity;
  let criteria;
  let conditionName;

  criteriaLoop: for (
    let criteriaIndex = 0;
    criteriaIndex < criterias.length;
    criteriaIndex += 1
  ) {
    const conditions = Object.values(
      conditionMap[criterias[criteriaIndex]].conditions
    );
    for (
      let conditionIndex = 0;
      conditionIndex < conditions.length;
      conditionIndex += 1
    ) {
      if (
        !isSameCondition(
          currentEntity,
          currentCriteria,
          currentCondtion.conditionName,
          entityLevel,
          criterias[criteriaIndex],
          conditions[conditionIndex].conditionName
        )
      ) {
        const otherCondition = conditions[conditionIndex];
        if (
          isConditionOverlapping(currentCondtion, otherCondition) &&
          !isCompatiblePropertyExist(
            Object.values(currentCondtion.properties),
            Object.values(otherCondition.properties)
          )
        ) {
          isIdenticalCondtions = true;
          entity = entityLevel;
          criteria = criterias[criteriaIndex];
          conditionName = conditions[conditionIndex].conditionName;
          break criteriaLoop;
        }
      }
    }
  }
  return {
    isIdenticalCondtions,
    entity,
    criteria,
    conditionName,
  };
};

const isConditionOverlapping = (currentCondtion, otherCondition) =>
  currentCondtion.pipeline === otherCondition.pipeline &&
  ((isIntersects(currentCondtion.stageFrom, otherCondition.stageFrom) &&
    isIntersects(currentCondtion.stageTo, otherCondition.stageTo)) ||
    ([...currentCondtion.stageFrom, ...otherCondition.stageFrom].includes(
      COMMON_PIPELINE_STAGES.ANY
    ) &&
      isIntersects(currentCondtion.stageTo, otherCondition.stageTo)) ||
    ([...currentCondtion.stageTo, ...otherCondition.stageTo].includes(
      COMMON_PIPELINE_STAGES.ANY
    ) &&
      isIntersects(currentCondtion.stageFrom, otherCondition.stageFrom)) ||
    ([...currentCondtion.stageTo, ...otherCondition.stageTo].includes(
      COMMON_PIPELINE_STAGES.ANY
    ) &&
      [...currentCondtion.stageFrom, ...otherCondition.stageFrom].includes(
        COMMON_PIPELINE_STAGES.ANY
      )));

const isCompatiblePropertyExist = (currentProperties, otherProperties) => {
  if (currentProperties?.length !== otherProperties?.length) {
    return true;
  }

  if (!currentProperties?.length > 0 && !otherProperties?.length > 0) {
    return false;
  }
  const currentPropertiesMap = currentProperties.map(
    ({ propertyId, objectType, propertyValue }) => ({
      propertyId,
      objectType,
      propertyValue,
    })
  );
  const otherPropertiesMap = otherProperties.map(
    ({ propertyId, objectType, propertyValue }) => ({
      propertyId,
      objectType,
      propertyValue,
    })
  );

  const isPropertiesMapEqual = function (cProperties, oProperties) {
    return _(cProperties).differenceWith(oProperties, _.isEqual).isEmpty();
  };

  return !isPropertiesMapEqual(currentPropertiesMap, otherPropertiesMap);
};

const isSameCondition = (
  entityLevel1,
  criteriaType1,
  conditionName1,
  entityLevel2,
  criteriaType2,
  conditionName2
) => {
  const isSame =
    entityLevel1 === entityLevel2 &&
    criteriaType1 === criteriaType2 &&
    conditionName1 === conditionName2;
  return isSame;
};

export const removeDuplicateEntry = (
  entityLevel,
  criteriaType,
  conditionName,
  duplicates
) => {
  const currentKey = `${entityLevel}-${criteriaType}-${conditionName}`;
  const newDuplicates = [];
  duplicates.forEach((duplicateCondtion) => {
    if (!duplicateCondtion.includes(currentKey)) {
      newDuplicates.push(duplicateCondtion);
    }
  });
  return newDuplicates;
};

export const getDuplicateCondtionDetails = (
  entityLevel,
  criteriaType,
  conditionName,
  duplicates
  // eslint-disable-next-line consistent-return
) => {
  // eslint-disable-next-line no-plusplus
  for (let conditionId = 0; conditionId < duplicates.length; conditionId++) {
    const [key1, key2] = duplicates[conditionId];
    const currentKey = `${entityLevel}-${criteriaType}-${conditionName}`;
    if (key1 === currentKey) {
      return key2;
    }
    if (key2 === currentKey) {
      return key1;
    }
  }
};

export const filterProperties = (properties, field, filterValues) => {
  if (!field || !filterValues || !Array.isArray(filterValues)) {
    return properties;
  }
  return properties?.filter((property) =>
    filterValues.includes(property[field])
  );
};

export const ExcludedProperties = (properties, field, excludedFieldType) => {
  if (!properties || !Array.isArray(properties) || !field) {
    return properties;
  }
  return properties?.filter(
    (property) => property[field] !== excludedFieldType
  );
};

export const isCompatibleFieldTypes = (velaris, crm) => {
  if (!velaris || !crm) {
    return true;
  }
  if (
    (crm === 'number' || crm === 'calculated') &&
    (velaris === 'string' || velaris === 'number')
  ) {
    return true;
  }
  return velaris === crm;
};

export const checkSelectedStages = (selectedStages, stages) => {
  if (selectedStages.includes(COMMON_PIPELINE_STAGES.ANY)) {
    return stages?.filter(({ id }) => selectedStages.includes(id));
  }

  return selectedStages?.length > 0
    ? stages?.filter(({ id }) => id !== COMMON_PIPELINE_STAGES.ANY)
    : stages;
};

export const filterSelectedStages = (previousSelectedStages, stages) => {
  return stages?.filter(({ id }) => !previousSelectedStages.includes(id));
};

export const isNextStateEnable = (
  currentConfigType,
  entityTab,
  sideNavBarTab,
  crmState
) => {
  let currentConfigStatus;

  if (currentConfigType === CONFIG_TYPES.CONDITIONS) {
    currentConfigStatus = findCondtionStatus(
      crmState[currentConfigType][entityTab][sideNavBarTab].conditions
    );
  }
  if (currentConfigType === CONFIG_TYPES.OBJECT_TYPE) {
    currentConfigStatus =
      crmState[currentConfigType][entityTab][sideNavBarTab]?.status;
  }

  return (
    currentConfigStatus === CONFIG_STATUS_LEVEL.COMPLETED ||
    currentConfigStatus === CONFIG_STATUS_LEVEL.SAVED
  );
};

const CRITERIA_DESC = {
  create: 'created',
  update: 'updated',
  churn: 'churned',
  archive: 'archived',
};

export const getConditionDescription = (entity, criteria) =>
  `${capitalizeFirstLetter(entity)} will be ${
    CRITERIA_DESC[criteria]
  } in Velaris when a Deal object in HubSpot matches the following conditions:`;

export const getFieldMappingDescription = (entity, criteria) => {
  const desc =
    entity === ENTITY_LEVEL.CONTACT
      ? FIELD_MAPPING_OUT_DESCRIPTION_CONTACT[criteria]
      : FIELD_MAPPING_OUT_DESCRIPTION[criteria];

  return desc.replace('entities', `${capitalizeFirstLetter(entity)}s`);
};

export const getVelarisCompanyProperties = (
  velarisProperties,
  entityLevel,
  syncDirection
) => {
  let filteredProperties = Object.values(velarisProperties);

  if (syncDirection !== SYNC_DIRECTION.OUT) {
    filteredProperties = filteredProperties.filter(
      ({ vertical, horizontal, horizontalCustom }) =>
        !vertical && !horizontal && !horizontalCustom
    );
  }
  const velarisCompanyProperties = [
    { name: 'externalId', displayName: 'External ID', dataType: 'string' },
    { name: 'about', displayName: 'About', dataType: 'string' },
    ...filteredProperties,
  ];

  if (entityLevel !== ENTITY_LEVEL.CONTACT)
    velarisCompanyProperties.push({
      name: 'primaryOwner',
      displayName: 'Primary Owner',
      dataType: 'user',
    });
  if (entityLevel === ENTITY_LEVEL.CONTACT)
    velarisCompanyProperties.push({
      name: 'email',
      displayName: 'Email',
      dataType: 'string',
    });

  if (syncDirection === SYNC_DIRECTION.OUT) {
    velarisCompanyProperties.push(
      {
        name: 'healthScore',
        displayName: 'Health Score',
        dataType: 'number',
      },
      {
        name: 'healthStatus',
        displayName: 'Health Status',
        dataType: 'string',
      },
      {
        name: 'lifecycleStage',
        displayName: 'Lifecycle Stage',
        dataType: 'string',
      },
      {
        name: 'pulse',
        displayName: 'Pulse',
        dataType: 'string',
      }
    );
    if (
      entityLevel === ENTITY_LEVEL.ORGANIZATION ||
      entityLevel === ENTITY_LEVEL.ACCOUNT
    )
      velarisCompanyProperties.push(
        {
          name: 'churnDate',
          displayName: 'Churn Date',
          dataType: 'date',
        },
        {
          name: 'churnReason',
          displayName: 'Churn Reason',
          dataType: 'string',
        },
        {
          name: 'churnComments',
          displayName: 'Churn Comments',
          dataType: 'string',
        },
        {
          name: 'nps',
          displayName: 'NPS',
          dataType: 'number',
        }
      );
    if (entityLevel === ENTITY_LEVEL.CONTACT) {
      velarisCompanyProperties.push(
        {
          name: 'npsCategory',
          displayName: 'NPS Category',
          dataType: 'string',
        },
        {
          name: 'npsRating',
          displayName: 'NPS Rating',
          dataType: 'number',
        }
      );
    }
  }

  if (
    entityLevel === ENTITY_LEVEL.OPPORTUNITY ||
    entityLevel === ENTITY_LEVEL.RISK
  ) {
    velarisCompanyProperties.filter((property) => property.name !== 'about');
  }
  return velarisCompanyProperties;
};

export const getCrmContactProperties = (
  contactProperties,
  entityTab,
  sideNavBarTab
) => {
  const newContactProperties = [...contactProperties];
  // combine hubspot first name and last name for entity-in-sync
  if (
    entityTab === ENTITY_LEVEL.CONTACT &&
    sideNavBarTab === SIDE_NAV_BAR_OPTIONS.IN_SYNC
  ) {
    newContactProperties.push({
      id: 'fnln',
      label: 'First Name & Last Name',
      fieldType: 'string',
    });
  }
  return newContactProperties;
};

export const getCrmDealProperties = (dealProperties, syncDirection) => {
  let updatedDealProperties = [...dealProperties];
  if (syncDirection === SYNC_DIRECTION.OUT) {
    updatedDealProperties = dealProperties.filter(
      (property) => property?.id !== 'pipeline'
    );
  }
  return updatedDealProperties;
};

export const getIntergrationContextForNoteSync = (
  entityLevel,
  criteria,
  noteSync
) => {
  const noteSyncString = getNoteSyncString(entityLevel, criteria);
  return { [noteSyncString]: noteSync ? 1 : 0 };
};

export const findNoteSyncIntergrationContext = (
  entityLevel,
  criteria,
  integrationContext
) => {
  const noteSyncString = getNoteSyncString(entityLevel, criteria);
  return integrationContext?.[noteSyncString];
};

export const getNoteSyncObj = (integrationContextValue) => ({
  noteSync: integrationContextValue === 1,
  status: CONFIG_STATUS_LEVEL.SAVED,
});

export const getParentLinkObj = (parentLinkData) => {
  parentLinkData.status = CONFIG_STATUS_LEVEL.SAVED;
  return parentLinkData;
};

export const getParentLinkCreateObj = (integrationContextValue) => ({
  enable: integrationContextValue === 1,
  status: CONFIG_STATUS_LEVEL.SAVED,
});

export const getDeduplicationUpdateObj = (integrationContextValue) => ({
  enable: integrationContextValue === 1,
  status: CONFIG_STATUS_LEVEL.SAVED,
});

export const getIntegrationContextValueObj = (integrationContextValue) => ({
  enable: integrationContextValue === 1,
  status: CONFIG_STATUS_LEVEL.SAVED,
});

export const getNoteSyncString = (entityLevel, criteria) => {
  return `noteSync${capitalizeFirstLetter(entityLevel)}${capitalizeFirstLetter(
    criteria
  )}`;
};

export const getConfigStatusKeyName = (
  settingType,
  entityLevel,
  criteria,
  syncType
) => {
  const key = `${settingType}${capitalizeFirstLetter(
    entityLevel
  )}${capitalizeFirstLetter(syncType)}${capitalizeFirstLetter(criteria)}`;
  return key;
};

export const getNoteSyncConfigName = (
  entityLevel,
  criteria,
  syncDirection,
  syncType
) => {
  return `${entityLevel}${capitalizeFirstLetter(
    criteria
  )}${capitalizeFirstLetter(syncDirection)}${capitalizeFirstLetter(
    syncType
  )}NoteSync`;
};
export const getDeduplicationObjType = (deduplicationMapping, entityLevel) => {
  return (
    deduplicationMapping?.[entityLevel]?.crmPropertyType?.fieldId ||
    CRM_DEFAULT_OBJ_BASED_ON_ENTITY[entityLevel]
  );
};

export const getParentDeduplicationObjType = (parentLink, entityLevel) => {
  return (
    parentLink?.[entityLevel]?.crmPropertyType?.fieldId ||
    CRM_DEFAULT_OBJ_BASED_ON_ENTITY[entityLevel]
  );
};
// before sending mappings to backend check crm fields and get vaild mappings
export const validateCrmFieldsInDataMappings = (
  datamappings,
  crmProperties
) => {
  const datamappingArray = Object.values(datamappings);
  const validDataMappings = [];
  datamappingArray.forEach((item) => {
    if (isFieldExist(item?.crm?.fieldId, crmProperties))
      validDataMappings.push(item);
  });
  return validDataMappings;
};

export const shouldDisplayParentLinkSwitch = (
  entityTab,
  syncDirection,
  sideNavBarTab
) =>
  entityTab === ENTITY_LEVEL.ACCOUNT &&
  syncDirection === SYNC_DIRECTION.IN &&
  (sideNavBarTab === SIDE_NAV_BAR_OPTIONS.CREATE ||
    sideNavBarTab === SIDE_NAV_BAR_OPTIONS.UPDATE ||
    sideNavBarTab === SIDE_NAV_BAR_OPTIONS.IN_SYNC);

export const getSideBarName = (sideNavBarTab) => {
  return sideNavBarTab.slice(0, -1);
};

export const transformEntityMappings = (
  entityMappings,
  includeType = false
) => {
  return Object.entries(entityMappings).reduce((acc, [entity, entityObj]) => {
    const { status, velaris, crm, type } = entityObj;
    const transformedEntity = {
      status,
      velaris: { fieldId: velaris?.fieldId },
      crm: { fieldId: crm?.fieldId },
      crmPropertyType: { fieldId: crm?.propertyType },
      ...(includeType ? { type } : {}),
    };
    return {
      ...acc,
      [entity]: transformedEntity,
    };
  }, {});
};

export const getParentLinkConfigStatus = (parentLinkData) =>
  parentLinkData?.status === CONFIG_STATUS_LEVEL.SAVED ? 1 : 0;

export const createCRMActivityTypeId = (category, id) =>
  `${capitalizeFirstLetter(category)}- ${id}`;

export const decodeCRMActivityTypeId = (
  crmActivityTypeId,
  crmActivityTypes
) => {
  const matchedActivityType = crmActivityTypes.find(
    (activityType) => activityType.label === crmActivityTypeId
  );

  // if matching label is found, extract the category and id
  if (matchedActivityType) {
    const { activityCategory: category, id: activityTypeId } =
      matchedActivityType;
    return [category, activityTypeId];
  }

  const [category, ...rest] = crmActivityTypeId.split('-');
  const activityTypeId = rest.join('');
  return [category, activityTypeId];
};

export const filterVelarisActivityTypes = (activityTypeLookup) => {
  const activityTypes = { ...activityTypeLookup };

  Object.keys(RESERVED_ACTIVITY_TYPES_LOOKUP).forEach((activityId) => {
    delete activityTypes[activityId];
  });

  return Object.values(activityTypes).filter(
    (activityType) => activityType.isActive
  );
};

export const buildCrmActivitySyncConfiguration = (
  integrationConfigs,
  activityTypeMapping
) => {
  const configurations = [];

  configurations.push({
    ...CRM_ACTIVITY_TYPE_TEMPLATE,
    syncType: INTEGRATION_SYNC_TYPE.NA,
    criteria: INTEGRATION_CRITERIA_TYPE.NA,
    enable: integrationConfigs.syncStatus ? 1 : 0,
  });

  configurations.push({
    ...CRM_ACTIVITY_TYPE_TEMPLATE,
    criteria: INTEGRATION_CRITERIA_TYPE.UPDATE,
    enable:
      integrationConfigs.historicalSync &&
      integrationConfigs.syncType === INTEGRATION_CRITERIA_TYPE.UPDATE
        ? 1
        : 0,
  });

  configurations.push({
    ...CRM_ACTIVITY_TYPE_TEMPLATE,
    criteria: INTEGRATION_CRITERIA_TYPE.CREATE,
    enable: integrationConfigs.historicalSync ? 1 : 0,
  });

  configurations.push({
    ...CRM_ACTIVITY_TYPE_TEMPLATE,
    syncType: INTEGRATION_SYNC_TYPE.DATA_DRIVEN,
    criteria: INTEGRATION_CRITERIA_TYPE.UPDATE,
    enable:
      integrationConfigs.dailySync &&
      integrationConfigs.syncType === INTEGRATION_CRITERIA_TYPE.UPDATE
        ? 1
        : 0,
  });

  configurations.push({
    ...CRM_ACTIVITY_TYPE_TEMPLATE,
    syncType: INTEGRATION_SYNC_TYPE.DATA_DRIVEN,
    criteria: INTEGRATION_CRITERIA_TYPE.CREATE,
    enable: integrationConfigs.dailySync ? 1 : 0,
  });

  return {
    integrationConfigs: configurations,
    activityMapping: activityTypeMapping,
  };
};

export const filterActivityTypeOptions = (
  activityTypeMapping,
  activityTypeId,
  crmActivityTypes
) => {
  const values = [];
  const selectedActivityType = (activityTypeMapping || []).find(
    (mapping) => mapping.velaris === activityTypeId
  );

  let filteredProperties = [...crmActivityTypes];
  if (selectedActivityType) {
    Object.keys(selectedActivityType.vendor).forEach((category) => {
      const selectedTypes = selectedActivityType.vendor[category];

      selectedTypes.forEach((selectedType) => {
        values.push(createCRMActivityTypeId(category, selectedType));
      });

      const selectedIds = selectedTypes.map((selectedType) =>
        createCRMActivityTypeId(category, selectedType)
      );

      filteredProperties = filteredProperties.map((property) => {
        if (selectedIds.includes(property.value)) {
          return {
            ...property,
            disabled: false,
          };
        }
        return property;
      });
    });
  }

  return [values, filteredProperties];
};

export const inSyncParentLinkWarning = (dataMapping, accDeduplication) => {
  const accountCreateMapping =
    dataMapping[SYNC_DIRECTION.IN][ENTITY_LEVEL.ACCOUNT][CRITERIA.CREATE]
      .dataMappings;
  if (accDeduplication.crmPropertyType.fieldId === PROPERTY_TYPE.DEAL) {
    return false;
  }
  if (
    accDeduplication.crmPropertyType.fieldId === PROPERTY_TYPE.COMPANY &&
    Object.values(accountCreateMapping).some((mapping) => {
      return (
        mapping?.crm?.fieldId === 'hs_object_id' &&
        mapping?.crmPropertyType?.fieldId === PROPERTY_TYPE.DEAL
      );
    })
  ) {
    return false;
  }
  return true;
};

export const isToggleEnable = (data, settingTypeValue) => {
  const settingItems = Object.values(data).filter(
    ({ settingType }) => settingType === settingTypeValue
  );
  const toggleEnable = {};

  settingItems.forEach((item) => {
    const keyName = `${item.entityLevel}${
      item.criteria.charAt(0).toUpperCase() + item.criteria.slice(1)
    }${
      item.syncDirection.charAt(0).toUpperCase() + item.syncDirection.slice(1)
    }`;
    toggleEnable[keyName] = item.enable;
  });

  return toggleEnable;
};

export const getNoteSyncSwitchTitle = (sideNavBarTab, vendor) => {
  let title = '';
  if (sideNavBarTab === SYNC_DIRECTION.IN) {
    title = `Sync Notes from ${CRM_VENDOR_NAMES[vendor]}`;
  } else if (sideNavBarTab === SYNC_DIRECTION.OUT) {
    title = `Sync Notes to ${CRM_VENDOR_NAMES[vendor]}`;
  }
  return title;
};

export const getNoteSyncCheckboxTitle = (
  direction,
  criteria,
  entityLevel,
  vendor
) => {
  let title = '';
  if (direction === SYNC_DIRECTION.IN) {
    if (criteria === CRITERIA.CREATE) {
      title = `Sync notes when creating ${capitalizeFirstLetter(entityLevel)}s`;
    }
    if (criteria === CRITERIA.UPDATE) {
      title = `Sync notes when updating ${capitalizeFirstLetter(entityLevel)}s`;
    }
    if (criteria === INTEGRATION_CRITERIA_TYPE.ALL) {
      title = 'Sync last 24 hours Notes on a daily basis';
    }
  }
  if (direction === SYNC_DIRECTION.OUT) {
    if (criteria === CRITERIA.CREATE) {
      title = `Create notes in ${CRM_VENDOR_NAMES[vendor]} when new notes are created in Velaris`;
    }
    if (criteria === CRITERIA.UPDATE) {
      title = `Update notes in ${CRM_VENDOR_NAMES[vendor]} when notes are updated in Velaris`;
    }
  }
  return title;
};

/**
 * This fuction give show tick mark in note sync side nav tabs
 * @param {*} entityLevel
 * @returns
 */
export const getStatusForNoteSyncSideBar = (savedIntegrationConfigs) => {
  const intoToggleStatus =
    savedIntegrationConfigs[
      getNoteSyncConfigName(
        ENTITY_LEVEL.ORGANIZATION,
        NA,
        COMMON_SYNC_DIRECTION.IN,
        NA
      )
    ] ||
    savedIntegrationConfigs[
      getNoteSyncConfigName(
        ENTITY_LEVEL.ACCOUNT,
        NA,
        COMMON_SYNC_DIRECTION.IN,
        NA
      )
    ]
      ? 1
      : 0;
  const outToggleStatus =
    savedIntegrationConfigs[
      getNoteSyncConfigName(
        ENTITY_LEVEL.ORGANIZATION,
        NA,
        COMMON_SYNC_DIRECTION.OUT,
        NA
      )
    ] ||
    savedIntegrationConfigs[
      getNoteSyncConfigName(
        ENTITY_LEVEL.ACCOUNT,
        NA,
        COMMON_SYNC_DIRECTION.OUT,
        NA
      )
    ]
      ? 1
      : 0;

  return { intoToggleStatus, outToggleStatus };
};
